import React from "react";
import { motion } from "framer-motion";
import { Search, TrendingUp, Users } from "lucide-react";
import { fadeUp, Section } from "./shared";

const STEPS = [
  { n: "01", t: "Clarity first", d: "See exactly what you qualify for, plus your business's key strengths and weaknesses.", i: Search },
  { n: "02", t: "Your best deal", d: "We match you to the lender most likely to approve — not the one paying us most.", i: TrendingUp },
  { n: "03", t: "A human in your corner", d: "A dedicated specialist supports your file end-to-end, right through to funding.", i: Users },
];

export const HowItWorks = () => (
  <Section id="how" className="py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <motion.p variants={fadeUp} className="text-[11px] font-bold tracking-[0.25em] uppercase text-[#052F24]/45 mb-4">
        The Growth Funds difference
      </motion.p>
      <motion.h2 variants={fadeUp} className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl max-w-3xl leading-[1.02]">
        You shouldn't have to figure this out alone.
      </motion.h2>
      <motion.p variants={fadeUp} custom={1} className="mt-5 max-w-xl text-lg font-light text-[#052F24]/60">
        Most "government funding" ads are lead-gen traps. We do it differently — in three deliberate steps.
      </motion.p>

      <div className="mt-16 grid md:grid-cols-3 gap-px bg-[#052F24]/10 border border-[#052F24]/10 rounded-3xl overflow-hidden">
        {STEPS.map((s, idx) => (
          <motion.div key={s.n} variants={fadeUp} custom={idx} className="bg-[#F6F5F2] p-8 sm:p-10 group hover:bg-white transition-colors duration-300">
            <div className="flex items-start justify-between mb-10">
              <span className="font-display font-extrabold text-5xl text-[#052F24]/15">{s.n}</span>
              <s.i className="text-[#052F24] group-hover:-translate-y-1 transition-transform duration-300" size={26} />
            </div>
            <h3 className="font-display font-extrabold text-2xl tracking-tight mb-3">{s.t}</h3>
            <p className="font-light text-[#052F24]/60">{s.d}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </Section>
);
